import { ComponentPropsWithoutRef, forwardRef } from "react";
import { Box } from "@mui/material";

type ModalContentProps = ComponentPropsWithoutRef<typeof Box>;

// MUI Modal requires a ref-forwarding child (see https://mui.com/r/caveat-with-refs-guide).
export const ModalContent = forwardRef<HTMLDivElement, ModalContentProps>(
  (props, ref) => (
    <Box
      ref={ref}
      alignItems="center"
      width={{ xs: "100%", sm: "25rem" }}
      {...props}
      sx={{
        position: "absolute" as "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "white",
        borderRadius: "1rem",
        ...props.sx,
      }}
    />
  )
);

ModalContent.displayName = "ModalContent";
